// extracted by mini-css-extract-plugin
module.exports = {"header":"header_header__3wy06"};